<page-title [title]="title"></page-title>

<form [formGroup]="form">
  <div class="row">
    <div class="col-xs-12 col-md-3">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Organização</mat-label>
        <mat-select formControlName="orgnizations" (selectionChange)="filterEncounters()">
          <mat-option *ngFor="let item of orgnizations" [value]="item.name">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-xs-12 col-md-3">
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label>Especialidade</mat-label>
        <mat-select formControlName="speciality" (selectionChange)="filterEncounters()">
          <mat-option *ngFor="let item of specialtys" [value]="item.name">
            {{ item.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-xs-12 col-md-4 d-flex align-items-center">
      <button mat-button color="primary" (click)="clearFilters()">Limpar Filtros</button>
    </div>
  </div>
</form>

<practitioner-page-scheduler [encounters]="filteredEncounters"></practitioner-page-scheduler>
